/* eslint-disable no-console */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import { Box, Stepper, Step, StepLabel, Button, Menu, MenuItem, IconButton, Fab, Divider, Typography } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RefreshIcon from "@mui/icons-material/Refresh";
import HomeIcon from "@mui/icons-material/Home";
import PersonalInformation from "components/applicationform/PersonalInformation";
import SocialService from "components/applicationform/SocialService";
import FamilyComposition from "components/applicationform/FamilyComposition";
import MedicalBackground from "components/applicationform/MedicalBackground";
import { createClient, getJsonFile, uploadJsonToS3, sendEmail, clearCredentialsCache, setCachedCredentials, hasCachedCredentials, checkForDuplicateChildName } from "api/case-management";
import { notification } from "antd";
import Skeleton from '@mui/material/Skeleton';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment';
import { useParams } from "react-router-dom";
import * as Constants from "constants/index";
import SimpleMobileScroll from 'components/mobile-nav-arrows/SimpleMobileScroll';
import { useErrorHandler, useAsyncError } from "hooks/useErrorHandling";
import { ERROR_TYPES } from "components/shared/ErrorContext";
import { personalInformationValidationSchema } from "validations/validationPersonalInformation";
import { childInformationValidationSchema } from "validations/validationSocialService";
import { familyCompositionValidationSchema } from "validations/validationFamilyComposition";
import { medicalBackgroundValidationSchema } from "validations/validationMedicalBackground";
import axios from "axios";

const styles = (theme) => ({
  rootGeneral: {
    flexGrow: 1,
    margin: "1% 2%",
    [theme.breakpoints.down('md')]: {
      margin: "0.5% 1%",
    },
    [theme.breakpoints.down('sm')]: {
      margin: "0",
      padding: "8px",
    },
  },
  root: {
    flexGrow: 1,
    margin: "0 2%",
    [theme.breakpoints.down('md')]: {
      margin: "0 1%",
    },
    [theme.breakpoints.down('sm')]: {
      margin: "0",
    },
  },
  nav: {
    width: "100%",
  },
  fieldset: {
    border: "4px solid #26516F",
    borderRadius: "50px",
    margin: "10px 20px",
    [theme.breakpoints.down('md')]: {
      borderRadius: "30px",
      margin: "5px 10px",
      border: "3px solid #26516F",
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: "20px",
      margin: "5px",
      border: "2px solid #26516F",
    },
  },
  legend: {
    color: "#26516F",
    fontSize: "2em",
    fontWeight: "700",
    marginLeft: "30px",
    padding: "0 10px",
    maxWidth: "425px",
    [theme.breakpoints.down('md')]: {
      fontSize: "1.5em",
      marginLeft: "20px",
      maxWidth: "300px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.2em",
      marginLeft: "10px",
      padding: "0 5px",
      maxWidth: "250px",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "1em",
      marginLeft: "5px",
      maxWidth: "200px",
    },
  },
  card: {
    padding: "10px 5px",
    textTransform: "uppercase",
    fontWeight: "bold",
    backgroundColor: "#1c5272",
    color: "#fff",
    textAlign: "center",
    [theme.breakpoints.down('sm')]: {
      padding: "8px 4px",
      fontSize: "0.7rem",
    },
    [theme.breakpoints.down('xs')]: {
      padding: "6px 2px",
      fontSize: "0.6rem",
    },
  },
  mobileActionBar: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "8px",
      "& > *": {
        marginBottom: "8px",
      },
    },
    [theme.breakpoints.down('xs')]: {
      gap: "4px",
      "& > *": {
        marginBottom: "4px",
      },
    },
  },
  qcResidentBox: {
    backgroundColor: "#28a745",
    color: "#fff",
    width: "100px",
    textAlign: "center",
    padding: "8px",
    borderRadius: "4px",
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      fontSize: "0.9rem",
      padding: "6px",
    },
  },
  mobileButton: {
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.8rem",
      padding: "6px 12px",
      minWidth: "unset",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.7rem",
      padding: "4px 8px",
    },
  },
  hamburgerMenu: {
    position: 'fixed',
    top: 20,
    right: 20,
    zIndex: 1300,
    backgroundColor: '#26516F',
    color: '#fff', 
    boxShadow: '0 8px 32px rgba(37, 81, 111, 0.3)',
    width: 56,
    height: 56,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      backgroundColor: '#1c3a52',
      transform: 'scale(1.05)',
      boxShadow: '0 12px 40px rgba(37, 81, 111, 0.4)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
    // Ensure it's always on the right
    left: 'auto !important',
  },
  desktopActionBar: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  menuPaper: {
    background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    minWidth: 240,
    overflow: 'hidden',
  },
  menuHeader: {
    background: 'linear-gradient(135deg, #26516F 0%, #1c3a52 100%)',
    color: '#fff',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  menuItem: {
    padding: '12px 20px',
    transition: 'all 0.2s ease',
    borderRadius: '0',
    '&:hover': {
      backgroundColor: 'rgba(37, 81, 111, 0.08)',
      transform: 'translateX(4px)',
    },
    '&:active': {
      backgroundColor: 'rgba(37, 81, 111, 0.12)',
    },
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
});

export const normalizeDraftStorageId = (id) => {
  if (id === null || id === undefined) return null;

  const normalizedId = id.toString().trim();
  return normalizedId || null;
};

export const getChildFullNameDraftId = (information = {}) => {
  const fullName = [
    information.firstName,
    information.middleName,
    information.surname,
    information.extension
  ]
    .map(normalizeDraftStorageId)
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return fullName || null;
};

export const resolveDraftStorageId = (qcId, userId, childInformation) => (
  normalizeDraftStorageId(qcId) ||
  normalizeDraftStorageId(userId) ||
  getChildFullNameDraftId(childInformation)
);

const extractMalformedUserDataField = (source, fieldNames) => {
  for (const fieldName of fieldNames) {
    const match = source.match(new RegExp(`(?:${fieldName})["'=:\\s]*"?([A-Za-z0-9._-]*)`, 'i'));

    if (match) {
      return { found: true, value: match[1] || null };
    }
  }

  return { found: false, value: null };
};

export const getDuplicateChildNameCheck = async (candidateInfo = null) => {
  // [AC-DUPCHLD1013-E2] Skip the lookup unless both surname and first name
  // are present; either one missing means the name cannot be evaluated.
  if (!candidateInfo || !candidateInfo.surname || !candidateInfo.firstName) {
    return { duplicate: false };
  }

  return checkForDuplicateChildName(candidateInfo);
};

export const shouldBlockDuplicateChildName = async (candidateInfo = null) => {
  const duplicateCheck = await getDuplicateChildNameCheck(candidateInfo);
  return Boolean(duplicateCheck?.duplicate);
};

export const parseApplicationUserData = (userData, search = '') => {
  const sources = [];

  if (userData) {
    sources.push(decodeURIComponent(userData));
  }

  if (search) {
    const queryString = search.startsWith('?') ? search.substring(1) : search;
    sources.push(decodeURIComponent(queryString));

    const params = new URLSearchParams(queryString);
    const userId = params.get('userId') || params.get('user_id');

    if (userId && !/[{}"',;&]/.test(userId)) {
      sources.push(JSON.stringify({
        user_id: userId,
        qcID: params.get('qcID') || params.get('qcid') || params.get('qcId') || undefined
      }));
    }
  }

  for (const source of sources) {
    if (!source) continue;

    try {
      const parsed = JSON.parse(source);
      if (parsed && typeof parsed === 'object') {
        const userId = parsed.user_id || parsed.userId;
        const qcID = parsed.qcID || parsed.qcid || parsed.qcId;

        if (userId || qcID) {
          return { user_id: userId || null, qcID: qcID || null };
        }
      }
    } catch (error) {
      // Fall through to malformed URL extraction below.
    }

    const htmlDecodedSource = source.replace(/&quot;/g, '"');
    const userIdField = extractMalformedUserDataField(htmlDecodedSource, ['user_id', 'userId']);
    const qcIdField = extractMalformedUserDataField(htmlDecodedSource, ['qcID', 'qcid', 'qcId']);

    if (userIdField.found || qcIdField.found) {
      return {
        user_id: userIdField.value,
        qcID: qcIdField.value
      };
    }
  }

  return { user_id: null, qcID: null };
};

const ApplicationForm = (props) => {
  const { userData } = useParams();

  const [qcid, setQcid] = useState('');
  const [userId, setUserId] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  
  // Global error handling
  const handleError = useErrorHandler();
  const { execute: executeAsync, isLoading: isAsyncLoading } = useAsyncError();
  
  // Track individual API loading states
  const [apiLoadingStates, setApiLoadingStates] = useState({
    userData: false,
    qcidData: false,
    uploadFiles: false
  });
  
  const [activeStep, setActiveStep] = useState(0);
  const steps = [
    "PERSONAL INFORMATION",
    "SOCIAL SERVICE",
    "FAMILY COMPOSITION",
    "MEDICAL BACKGROUND",
  ];
  const [isNavigating, setIsNavigating] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [showReferenceDialog, setShowReferenceDialog] = useState(false);
  const [retrievedData, setRetrievedData] = useState(null);
  const [personalInformation, setPersonalInformation] = useState({
    ...Constants.CHILD_INFORMATION,
    ...Constants.PARENT_INFORMATION
  });
  const [socialServiceInformation, setSocialServiceInformation] = useState(Constants.SOCIAL_SERVICE_INFORMATION);
  const [familyCompositionInformation, setFamilyCompositionInformation] = useState(Constants.FAMILY_COMPOSITION_INFORMATION);
  const [medicalBackgroundInformation, setMedicalBackgroundInformation] = useState(Constants.MEDICAL_BACKGROUND_INFORMATION);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const getDraftStorageId = (data = personalInformation) => resolveDraftStorageId(qcid, userId, data);

  // Helper function to update API loading state and manage overall loading
  const updateApiLoadingState = (apiName, isLoading, message = '') => {
    setApiLoadingStates(prev => {
      const newState = { ...prev, [apiName]: isLoading };
      
      // Check if any API is still loading
      const anyLoading = Object.values(newState).some(loading => loading);
      
      // Update overall loading state
      setIsLoading(anyLoading);
      if (message) setLoadingMessage(message);

      return newState;
    });
  };

  // Helper function to handle API errors using global error handling
  const handleApiError = (apiName, error, fallbackMessage = 'An unexpected error occurred') => {
    console.error(`${apiName} API Error:`, error.message || error);
    
    // Determine error type based on error characteristics
    let errorType = ERROR_TYPES.UNKNOWN;
    
    if (error.response) {
      const status = error.response.status;
      
      if (status === 401) {
        errorType = ERROR_TYPES.AUTHENTICATION;
      } else if (status === 403) {
        errorType = ERROR_TYPES.AUTHORIZATION;
      } else if (status === 400) {
        errorType = ERROR_TYPES.VALIDATION;
      } else if (status === 404) {
        errorType = ERROR_TYPES.NOT_FOUND;
      } else if (status >= 500) {
        errorType = ERROR_TYPES.SERVER;
      } else {
        errorType = ERROR_TYPES.NETWORK;
      }
    } else if (error.request) {
      errorType = ERROR_TYPES.NETWORK;
    } else {
      errorType = ERROR_TYPES.APPLICATION;
    }
    
    // Use global error handler
    handleError(error, errorType, {
      showModal: true,
      showNotification: false, // Don't show notification since modal will be shown
      retryable: errorType === ERROR_TYPES.NETWORK || errorType === ERROR_TYPES.SERVER,
      onRetry: () => {
        // Reset loading states and retry initialization
        setIsDataLoaded(false);
        setApiLoadingStates({
          userData: false,
          qcidData: false,
          uploadFiles: false
        });
        setTimeout(() => {
          retrieveQcId(userData);
        }, 500);
      },
      metadata: {
        apiName,
        fallbackMessage,
        url: window.location.href,
      },
    });
    
    setIsLoading(false);
    
    // Stop all API loading states
    setApiLoadingStates({
      userData: false,
      qcidData: false,
      uploadFiles: false
    });
  };

  const retrieveQcId = async (userData) => {
    try {
      updateApiLoadingState('userData', true, 'Parsing user data...');
      const dynamicObject = parseUserData(userData);
      setUserId(dynamicObject.user_id || '');

      if (dynamicObject.qcID) {
        await fetchAndUpdateQcidData(dynamicObject.qcID);
        // getUploadFiles will be called by useEffect when qcid changes
      } else if (dynamicObject.user_id) {
        // No qcID means no second API call, and we use userId for upload files
        updateApiLoadingState('qcidData', false); // Mark qcid API as not needed
        await getUploadFiles(dynamicObject.user_id);
      } else {
        updateApiLoadingState('qcidData', false);
        updateApiLoadingState('uploadFiles', false);
      }
      
      updateApiLoadingState('userData', false);
    } catch (error) {
      updateApiLoadingState('userData', false);
      handleApiError('User Data', error, 'Failed to process user information');
    }
  };

  const parseUserData = (userData) => {
    const parsed = parseApplicationUserData(userData, window.location.search);

    if (!parsed.user_id && !parsed.qcID) {
      console.log('No user ID or QC ID found in route or query string; draft saving will fall back to child full name.');
    }

    return parsed;
  };

  const fetchAndUpdateQcidData = async (qcID) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      updateApiLoadingState('qcidData', true, 'Fetching QC ID information...');

      // [SECBACK0701] Call backend proxy instead of external API directly
      const proxyUrl = `${process.env.REACT_APP_API}/qcid_lookup`;
      
      const response = await axios.post(proxyUrl, { qcID }, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        timeout: 30000
      });

      if (response.status !== 200) {
        throw new Error(`Server error: ${response.status}`);
      }

      const qcid_data_json = response.data;

      setQcid(qcID);
      updateParentInformation(qcid_data_json);
      updateApiLoadingState('qcidData', false);
    } catch (error) {
      updateApiLoadingState('qcidData', false);
      handleApiError('QC ID Information', error, 'Failed to fetch QC ID information');
    }
  };


  const updateParentInformation = (result) => {
    const parentData = result.result;
    if (parentData.status_code === "GC0") {
      setPersonalInformation((prevInfo) => ({
        ...prevInfo,

        parentSurname: parentData.last_name || prevInfo.parentSurname,
        parentFirstName: parentData.first_name || prevInfo.parentFirstName,
        parentMiddleName: parentData.middle_name || prevInfo.parentMiddleName,
        parentExtension: parentData.suffix_name || prevInfo.parentExtension,
        parentBirthday: parentData.birthday || prevInfo.parentBirthday,
        parentGender: parentData.gender_name || prevInfo.parentGender,
        parentEmailAddress: parentData.email || prevInfo.parentEmailAddress,
        parentCellphone: (parentData.mobile_no || prevInfo.parentCellphone).replace(/\s+/g, ''),

        // Address
        houseNo: parentData.house_no || prevInfo.houseNo,
        street: parentData.street || prevInfo.street,
        district: parentData.district_name || prevInfo.district,
        zipCode: parentData.zipcode || prevInfo.zipCode,
        barangay: parentData.Barangay || prevInfo.barangay,
        city: parentData.City || prevInfo.city,

        parentCivilStatus: parentData.MaritalStatus || prevInfo.parentCivilStatus,
        parentQcIdStatus: 'Meron',
        parentQcId: parentData.qcid_no || prevInfo.parentQcId
      }));
    }
  };


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!isNavigating) {
        // Custom message for accidental page close or navigation
        event.preventDefault();
        event.returnValue = ''; // Trigger a confirmation dialog
      }
    };

    const handleUnload = (event) => {
      if (!isNavigating) {
        // Handle any cleanup or data saving here before unload
        clearCredentialsCache();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

    // Cleanup function
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      // Clear credentials when event listeners are cleaned up
      clearCredentialsCache();
    };
  }, [isNavigating]); // Depend on isNavigating state

  useEffect(() => {
    if (qcid) {
      getUploadFiles(qcid); // Only call this when qcid is available
    }
  }, [qcid]); // This useEffect depends on qcid

  useEffect(() => {
    retrieveQcId(userData);
    
    // Preload credentials on component mount
    preloadCredentials();
  }, []);

  // Preload credentials function
  const preloadCredentials = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_GET_CREDENTIALS);
      const data = await response.json();
      setCachedCredentials(data.credentials);
      
      // Make debug function globally accessible for testing
      window.hasCachedCredentials = hasCachedCredentials;
      window.clearCredentialsCache = clearCredentialsCache;
    } catch (error) {
      console.error('Failed to preload credentials:', error);
      // Don't throw error, let individual API calls handle credential fetching
    }
  };

  // Cleanup credentials when component unmounts
  useEffect(() => {
    return () => {
      clearCredentialsCache();
    };
  }, []);

  // Effect to set isDataLoaded when all API calls are complete
  useEffect(() => {
    const allApisComplete = !Object.values(apiLoadingStates).some(loading => loading);
    if (allApisComplete && !isDataLoaded && !open) {
      // Only auto-set if modal is not open (to avoid conflicts with manual choices)
      // Small delay to ensure UI updates smoothly
      setTimeout(() => {
        setIsDataLoaded(true);
      }, 300);
    }
  }, [apiLoadingStates, isDataLoaded, open]);

  // Debug effect to track personalInformation changes
  useEffect(() => {
  }, [personalInformation]);

  // Debug effect to track isDataLoaded changes
  useEffect(() => {
  }, [isDataLoaded]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Set data as loaded since user chose not to use existing data (start fresh)
    setIsDataLoaded(true);
  };

  const handleGoBackHome = () => {
    // Clear credentials cache when navigating to home
    clearCredentialsCache();
    
    const currentUrl = window.location.pathname;

    // Extract the base URL up to "/kabahagi" and the dynamic part after "/application-form"
    const baseUrl = currentUrl.split("/kabahagi")[0]; // This gives everything before "/kabahagi"
    const dynamicPart = currentUrl.split("/application-form")[1]; // This gives the dynamic part after "/application-form"

    // Construct the new URL without "application-form" and keep the dynamic part
    const homeUrl = `${baseUrl}/kabahagi${dynamicPart ? dynamicPart : ''}`;

    // Navigate to the new home URL (without application-form)
    window.location = homeUrl;
  };

  const handleYesClick = () => {
    
    if (retrievedData) {
      try {
        // Validate data structure
        const sections = ['personalInformation', 'socialServiceInformation', 'familyCompositionInformation', 'medicalBackgroundInformation'];
        const isValidData = sections.every(section => retrievedData[section] !== undefined);

        if (!isValidData) {
          throw new Error('Invalid draft data structure: one or more required sections are missing.');
        }

        // Update all state data
        const newPersonalInfo = {
          ...personalInformation,
          ...(retrievedData.personalInformation || {}),
        };
        
        const newSocialServiceInfo = {
          ...socialServiceInformation,
          ...(retrievedData.socialServiceInformation || {}),
        };
        
        const newMedicalInfo = {
          ...medicalBackgroundInformation,
          ...(retrievedData.medicalBackgroundInformation || {}),
        };

        setPersonalInformation(newPersonalInfo);
        setSocialServiceInformation(newSocialServiceInfo);
        setFamilyCompositionInformation(retrievedData.familyCompositionInformation || []);
        setMedicalBackgroundInformation(newMedicalInfo);
      } catch (error) {
        console.error('Error restoring draft:', error);
        notification["error"]({
          message: "Error",
          description: `Failed to restore draft: ${error.message}`,
        });
        handleClose();
        return;
      }
    }
    
    // Close modal and set data as loaded
    setOpen(false);
    
    // Use setTimeout to ensure state updates are processed before setting isDataLoaded
    setTimeout(() => {
      setIsDataLoaded(true);
    }, 100);
  };


  const getUploadFiles = async (draftId) => {
    try {
      updateApiLoadingState('uploadFiles', true, 'Checking for saved draft...');
      const fileName = qcid.toString();

      const response = await getJsonFile(fileName);
      const data = response.data.data;
      
      if (response.data.message === "File retrieved successfully") {
        setRetrievedData(data);
        handleOpen();
        
        notification["success"]({
          message: "Success",
          description: `Successfully retrieved saved draft`,
          duration: 4,
        });
      } else {
        notification["error"]({
          message: "Error",
          description: `No saved draft found`,
          duration: 4,
        });
      }
      
      updateApiLoadingState('uploadFiles', false);
    } catch (error) {
      updateApiLoadingState('uploadFiles', false);
      
      // Handle specific case where no draft exists (not really an error)
      if (error.response && error.response.data && error.response.data.message === "File not found in S3") {
        return; // Don't show error UI for missing draft
      }
      
      // For all other errors, show the error UI
      handleApiError('Draft Data', error, 'Failed to check for saved draft');
    }
  }

  const saveAsDraft = async (draftId, data, showLoadingOverlay = true) => {
    try {
      if (showLoadingOverlay) {
        setIsLoading(true);
        setLoadingMessage('Saving draft...');
      }
      
      const fileName = qcid.toString();
      
      // Create a copy of data to avoid modifying the original
      const dataToSave = JSON.parse(JSON.stringify(data));
      dataToSave.personalInformation.certificateOfDisabilityImage = "";
      dataToSave.personalInformation.lastCheckUp = "";
      dataToSave.medicalBackgroundInformation.signature = "";
      // [AC-FILEUPL0318-F5] File objects are non-serializable; clear before S3 JSON upload
      // [OWASP:A03] Prevents accidental inclusion of binary data in JSON payload
      dataToSave.medicalBackgroundInformation.requirementFiles = [];
      
      const result = await uploadJsonToS3(fileName, dataToSave);
      
      if (showLoadingOverlay) {
        notification["success"]({
          message: "Success",
          description: "Data saved as draft successfully",
          duration: 4,
        });
      }
      
      return result;
    } catch (error) {
      console.error('Save draft error:', error);
      if (showLoadingOverlay) {
        notification["error"]({
          message: "Error",
          description: "Failed to save data as draft",
          duration: 4,
        });
      }
      throw error; // Re-throw for auto-save error handling
    } finally {
      if (showLoadingOverlay) {
        setIsLoading(false);
      }
    }
  }

  const handleNext = async (updatedPersonalInfo = null) => {
    // Prevent multiple simultaneous calls
    // Consider adding debounce logic for auto-save to prevent excessive API calls
    if (isNextLoading) {
      return;
    }

    try {
      setIsNextLoading(true);
      
      // Use updated personal info if provided, otherwise use current state
      const currentPersonalInfo = updatedPersonalInfo || personalInformation;

      if (activeStep === 0 && currentPersonalInfo) {
        const duplicateCheck = await getDuplicateChildNameCheck(currentPersonalInfo);

        if (duplicateCheck?.duplicate) {
          notification.error({
            message: 'Duplicate Child Name',
            description: duplicateCheck.message || 'A child with the same surname, first name, and birthdate already exists in the database. Please review the entry before continuing to Social Service.',
            duration: 6,
            placement: 'topRight',
          });
          return;
        }
      }
      
      // Auto-save before moving to next step (when leaving step 0 or higher - after Personal Information is filled)
      if (activeStep >= 0 && isDataLoaded) {
        try {
          // Validate that we have essential data before saving
          const hasEssentialData = currentPersonalInfo.parentFirstName && 
                                  currentPersonalInfo.parentSurname && 
                                  getDraftStorageId(currentPersonalInfo);

          if (hasEssentialData) {
            const currentData = {
              personalInformation: currentPersonalInfo,
              socialServiceInformation,
              familyCompositionInformation,
              medicalBackgroundInformation
            };
            
            // Silent auto-save without loading overlay
            await saveAsDraft(getDraftStorageId(currentPersonalInfo), currentData, false);
            
            // Show subtle success notification for auto-save
            notification["info"]({
              message: "Progress Auto-Saved",
              description: "Your form data has been automatically saved",
              duration: 2,
              placement: 'topRight',
              style: {
                backgroundColor: '#f6ffed',
                border: '1px solid #b7eb8f',
              }
            });
          } else {
          }
        } catch (error) {
        console.error('Auto-save error at step:', activeStep, error);
        // Don't block navigation if auto-save fails, just notify
        notification["warning"]({
          message: "Auto-save Failed",
          description: "Unable to save progress, but you can continue",
          duration: 3,
          placement: 'topRight'
        });
      }
    } else {
    }

    if (activeStep === 1) {
      const data = currentPersonalInfo;
      const formattedDate = data.parentBirthday ? moment(data.parentBirthday).format("MM-DD-YYYY") : '';
      
      // Build the full parent name
      const nameParts = [data.parentFirstName, data.parentMiddleName, data.parentSurname, data.parentExtension].filter(Boolean);
      const fullName = nameParts.join(' ');
      
      const newFamilyCompositionInformation = familyCompositionInformation.length > 0 
        ? familyCompositionInformation.map((info, index) => {
            if (index === 0) {
              return {
                ...info,
                name: fullName,
                birthday: formattedDate,
                gender: data.parentGender,
                relationshipToChild: "Magulang/Guardian",
                civilStatus: data.parentCivilStatus,
                educationalAttainment: data.parentEducationalAttainment === "IbaPa" ? data.parentSpecificEducationalAttainment : data.parentEducationalAttainment,
                work: data.parentWork || info.work || "",
                workPlace: data.parentWorkPlace || info.workPlace || "",
                salaryPerMonth: data.parentSalaryPerMonth || info.salaryPerMonth || "",
                OtherInterests: data.parentOtherInterests || info.OtherInterests || "",
                pwdId: data.parentPwdId || info.pwdId || "",
                illness: data.parentIllness || info.illness || "",
                philhealthNumber: data.parentPhilhealthNumber || info.philhealthNumber || "",
                vaccineStatus: data.parentVaccineStatus === "Oo" ? data.parentVaccineShotCount : "None",
              };
            }
            return info;
          })
        : [{
            name: fullName,
            birthday: formattedDate,
            gender: data.parentGender,
            relationshipToChild: "Magulang/Guardian",
            civilStatus: data.parentCivilStatus,
            educationalAttainment: data.parentEducationalAttainment === "IbaPa" ? data.parentSpecificEducationalAttainment : data.parentEducationalAttainment,
            work: data.parentWork || "",
            workPlace: data.parentWorkPlace || "",
            salaryPerMonth: data.parentSalaryPerMonth || "",
            OtherInterests: data.parentOtherInterests || "",
            pwdId: data.parentPwdId || "",
            illness: data.parentIllness || "",
            philhealthNumber: data.parentPhilhealthNumber || "",
            vaccineStatus: data.parentVaccineStatus === "Oo" ? data.parentVaccineShotCount : "None",
          }];

      setFamilyCompositionInformation(newFamilyCompositionInformation);
    }
    
    setActiveStep(prevStep => prevStep + 1);
    
    } catch (error) {
      console.error('Error in handleNext:', error);
      notification.error({
        message: 'Navigation Error',
        description: 'An error occurred while navigating. Please try again.',
        duration: 4,
        placement: 'topRight'
      });
    } finally {
      setIsNextLoading(false);
    }
  }

  const handleBack = () => {
    setActiveStep(prevStep => prevStep - 1);
  }

  const handlePersonalInformation = (info) => {
    setPersonalInformation(info);
  }

  const handleSocialService = (info) => {
    setSocialServiceInformation(info);
  }

  const handleFamilyComposition = (info) => {
    setFamilyCompositionInformation(info);
  }

  const handleMedicalBackground = (info) => {
    setMedicalBackgroundInformation(info);
  }

  /**
   * Validates all steps (1-4) before final submission
   * Returns an object with validation status and any errors
   */
  const validateAllSteps = async (latestMedicalBackgroundInformation = medicalBackgroundInformation) => {
    const validationResults = {
      step1: { isValid: true, errors: {} },
      step2: { isValid: true, errors: {} },
      step3: { isValid: true, errors: {} },
      step4: { isValid: true, errors: {} },
    };

    try {
      // Step 1: Personal Information
      await personalInformationValidationSchema.validate(personalInformation, { abortEarly: false });
    } catch (error) {
      validationResults.step1.isValid = false;
      if (error.inner) {
        error.inner.forEach(err => {
          validationResults.step1.errors[err.path] = err.message;
        });
      }
    }

    try {
      // Step 2: Social Service
      await childInformationValidationSchema.validate(socialServiceInformation, { abortEarly: false });
    } catch (error) {
      validationResults.step2.isValid = false;
      if (error.inner) {
        error.inner.forEach(err => {
          validationResults.step2.errors[err.path] = err.message;
        });
      }
    }

    try {
      // Step 3: Family Composition - validate each family member
      if (!familyCompositionInformation || familyCompositionInformation.length === 0) {
        throw new Error('At least one family member is required');
      }
      
      for (let i = 0; i < familyCompositionInformation.length; i++) {
        await familyCompositionValidationSchema.validate(familyCompositionInformation[i], { abortEarly: false });
      }
    } catch (error) {
      validationResults.step3.isValid = false;
      if (error.inner) {
        error.inner.forEach(err => {
          validationResults.step3.errors[err.path] = err.message;
        });
      } else {
        validationResults.step3.errors['general'] = error.message;
      }
    }

    try {
      // Step 4: Medical Background
      await medicalBackgroundValidationSchema.validate(latestMedicalBackgroundInformation, { abortEarly: false });
    } catch (error) {
      validationResults.step4.isValid = false;
      if (error.inner) {
        error.inner.forEach(err => {
          validationResults.step4.errors[err.path] = err.message;
        });
      }
    }

    // Check if all steps are valid
    const allStepsValid = Object.values(validationResults).every(step => step.isValid);

    return {
      isValid: allStepsValid,
      results: validationResults
    };
  };

  const handleSubmit = async (medicalBackgroundInfo) => {
    try {
      // First, validate all steps
      const validation = await validateAllSteps(medicalBackgroundInfo);

      if (!validation.isValid) {
        // Find the first invalid step
        let firstInvalidStep = 0;
        const stepNames = ['Personal Information', 'Social Service', 'Family Composition', 'Medical Background'];
        
        for (let i = 1; i <= 4; i++) {
          const stepKey = `step${i}`;
          if (!validation.results[stepKey].isValid) {
            firstInvalidStep = i - 1; // Convert to 0-indexed
            
            // Get error count for this step
            const errorCount = Object.keys(validation.results[stepKey].errors).length;
            const errorList = Object.entries(validation.results[stepKey].errors)
              .slice(0, 3) // Show first 3 errors
              .map(([field, message]) => `• ${message}`)
              .join('\n');
            
            // Show detailed error notification
            notification.error({
              message: `Validation Failed - Step ${i}: ${stepNames[i - 1]}`,
              description: (
                <div>
                  <p style={{ marginBottom: '8px', fontWeight: 600 }}>
                    {errorCount} required field{errorCount > 1 ? 's are' : ' is'} incomplete or invalid:
                  </p>
                  <div style={{ whiteSpace: 'pre-line', fontSize: '0.9em' }}>
                    {errorList}
                    {errorCount > 3 && <div>• ...and {errorCount - 3} more</div>}
                  </div>
                  <p style={{ marginTop: '12px', fontStyle: 'italic', color: '#666' }}>
                    Please go to Step {i} and complete all required fields.
                  </p>
                </div>
              ),
              duration: 8,
              placement: 'topRight',
              style: {
                width: 450,
              }
            });
            
            // Navigate to the first invalid step
            setActiveStep(firstInvalidStep);
            
            // Scroll to top of the page
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            return; // Stop submission
          }
        }
      }

      // All validations passed - proceed with submission
      setIsLoading(true);
      setLoadingMessage('Creating case...');
      const response = await createClient(
        personalInformation,
        familyCompositionInformation,
        socialServiceInformation,
        medicalBackgroundInfo
      );

      if (!response?.data?.success) return;
      const data = response.data;

      if (data.reference_number) {
        const emailData = {
          email: personalInformation.parentEmailAddress,
          message: `Your Reference Number is: <strong>${data.reference_number}</strong`,
          subject: `Kabahagi Online Application - Reference Number`
        }
        sendEmail(emailData);
        setReferenceNumber(data.reference_number);
        setIsNavigating(true); // Set navigating to true to allow page close
        setShowReferenceDialog(true);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSaveDraft = () => {
    saveAsDraft(getDraftStorageId(), {
      personalInformation, 
      socialServiceInformation, 
      familyCompositionInformation, 
      medicalBackgroundInformation
    }, true); // Show loading overlay for manual save
    handleMenuClose();
  };

  const handleGoHome = () => {
    handleGoBackHome();
    handleMenuClose();
  };

  const { classes } = props;
  
  return (
    <div className={classes.rootGeneral}>
      {/* Loading UI */}
      {isLoading && (
        <div
        role="status"
            aria-live="polite"
            aria-busy="true"
            style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            animation: 'fadeIn 0.3s ease-in-out'
          }}
        >
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '20px',
              padding: '40px 60px',
              textAlign: 'center',
              boxShadow: '0 25px 80px rgba(0, 0, 0, 0.25), 0 10px 40px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              maxWidth: '480px',
              margin: '20px',
              animation: 'slideInUp 0.4s ease-out'
            }}
          >
                {/* Spinner Animation */}
                <div
                  style={{
                    width: '60px',
                    height: '60px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #26516F',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 24px auto'
                  }}
                  aria-hidden="true"
                />
                <p 
                  style={{
                    margin: 0,
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#26516F',
                    letterSpacing: '0.5px',
                    lineHeight: '1.4'
                  }}
                >
                  <span className="sr-only">Loading: </span>
                  Please wait for further instructions regarding your application.<br /><br />
                  <span style={{ fontWeight: 400, color: '#222', fontSize: '16px' }}>
                    Retain this reference number to track your status on the Kabahagi landing page under <b>Application Status</b> by entering it in the designated text field. This reference number will also be sent to your registered email address.
                  </span>
                </p>
                <style jsx="true">{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
              
                  @keyframes fadeIn {
                to { 
                  opacity: 1;
                  transform: translateY(0) scale(1);
                }
              }
            `}</style>
          </div>
        </div>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            margin: { xs: '16px', sm: '32px' },
            width: { xs: 'calc(100% - 32px)', sm: 'auto' },
            maxHeight: { xs: 'calc(100% - 32px)', sm: 'auto' },
          },
          '& .MuiDialogTitle-root': {
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
            padding: { xs: '12px 16px', sm: '16px 24px' },
          },
          '& .MuiDialogContent-root': {
            padding: { xs: '8px 16px', sm: '8px 24px' },
          },
          '& .MuiDialogActions-root': {
            padding: { xs: '8px 16px 16px', sm: '8px 24px 24px' },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Keep Current Data?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to use the information you already have?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleClose} 
            color="primary"
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.875rem' },
              padding: { xs: '6px 12px', sm: '8px 16px' },
            }}
          >
            No
          </Button>
          <Button 
            onClick={handleYesClick} 
            color="primary" 
            autoFocus
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.875rem' },
              padding: { xs: '6px 12px', sm: '8px 16px' },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showReferenceDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            margin: { xs: '16px', sm: '32px' },
            width: { xs: 'calc(100% - 32px)', sm: 'auto' },
            maxHeight: { xs: 'calc(100% - 32px)', sm: 'auto' },
          },
          '& .MuiDialogTitle-root': {
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
            padding: { xs: '12px 16px', sm: '16px 24px' },
          },
          '& .MuiDialogContent-root': {
            padding: { xs: '8px 16px', sm: '8px 24px' },
          },
          '& .MuiDialogActions-root': {
            padding: { xs: '8px 16px 16px', sm: '8px 24px 24px' },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">{"Case Created Successfully"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your reference number is: <strong>{referenceNumber}</strong>.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleGoBackHome} 
            color="primary" 
            autoFocus
            sx={{
              fontSize: { xs: '0.8rem', sm: '0.875rem' },
              padding: { xs: '6px 12px', sm: '8px 16px' },
            }}
          >
            Go Back to Home
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.right_nav}>
        <fieldset className={classes.fieldset}>
          <legend className={classes.legend}>
            Kabahagi Application Form
          </legend>
          <Box sx={{ p: { xs: "8px", lg: "16px" } }}>
            <div className={classes.root}>
              {/* Professional Hamburger Menu for Mobile */}
              <Fab
                className={classes.hamburgerMenu}
                size="medium"
                onClick={handleMenuOpen}
                aria-controls={menuOpen ? 'action-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
                aria-label="Application menu"
                sx={{
                  position: 'fixed !important',
                  top: '20px !important',
                  right: '20px !important',
                  left: 'auto !important',
                  zIndex: 1300,
                  backgroundColor: '#265170',
                  color: '#fff',
                  display: { xs: 'flex', sm: 'none' },
                  '&:hover': {
                    backgroundColor: '#1c3a52',
                  }
                }}
              >
                <MenuIcon />
              </Fab>

              {/* Professional Dropdown Menu */}
              <Menu
                id="action-menu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                slotProps={{
                  paper: {
                    className: classes.menuPaper,
                    sx: {
                      mt: 2,
                      background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)',
                      borderRadius: '16px',
                      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 20px rgba(0, 0, 0, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      minWidth: 240,
                      overflow: 'hidden',
                    }
                  }
                }}
              >
                {/* Menu Header */}
                <Box 
                  sx={{
                    background: 'linear-gradient(135deg, #26516F 0%, #1c3a52 100%)',
                    color: '#fff',
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <CheckCircleIcon fontSize="small" />
                  <Typography variant="subtitle2" fontWeight="600">
                    QC Resident
                  </Typography>
                </Box>

                <Divider sx={{ margin: 0 }} />

                {/* Save Draft Option */}
                {isDataLoaded && (
                  <MenuItem 
                    onClick={handleSaveDraft}
                    disabled={activeStep === 0}
                    className={classes.menuItem}
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: 2,
                      padding: '12px 20px',
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(37, 81, 111, 0.08)',
                        transform: 'translateX(4px)',
                      },
                    }}
                  >
                    <SaveIcon 
                      fontSize="small" 
                      sx={{ 
                        color: activeStep === 0 ? 'rgba(0,0,0,0.38)' : '#26516F' 
                      }} 
                    />
                    <Box>
                      <Typography variant="body2" fontWeight="500">
                        Save as Draft
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {activeStep === 0 ? 'Complete first step to save' : 'Save your progress'}
                      </Typography>
                    </Box>
                  </MenuItem>
                )}

                <Divider sx={{ margin: '4px 0' }} />

                {/* Go Home Option */}
                <MenuItem 
                  onClick={handleGoHome}
                  className={classes.menuItem}
                  sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 2,
                    padding: '12px 20px',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(37, 81, 111, 0.08)',
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <HomeIcon 
                    fontSize="small" 
                    sx={{ color: '#26516F' }} 
                  />
                  <Box>
                    <Typography variant="body2" fontWeight="500">
                      Return to Home
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Exit application form
                    </Typography>
                  </Box>
                </MenuItem>
              </Menu>

              {/* Professional Desktop Action Bar */}
              <Box
                className={`${classes.mobileActionBar} ${classes.desktopActionBar}`}
                sx={{
                  display: { xs: "none", sm: "flex" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                  borderRadius: '12px',
                  padding: '12px 16px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  border: '1px solid rgba(37, 81, 111, 0.1)',
                }}
                mb={2}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: "#28a745",
                    color: "#fff",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    fontSize: "0.875rem",
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)',
                  }}
                >
                  <CheckCircleIcon fontSize="small" />
                  QC Resident
                </Box>
                
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                  {isDataLoaded && (
                    <Button 
                      variant="contained" 
                      size="medium"
                      onClick={() =>
                        saveAsDraft(getDraftStorageId(),
                          {
                            personalInformation, socialServiceInformation, familyCompositionInformation, medicalBackgroundInformation
                          },
                          true // Show loading overlay for manual save
                        )
                      }
                      startIcon={<SaveIcon />}
                      disabled={activeStep === 0}
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 500,
                        padding: "8px 20px",
                        borderRadius: "8px",
                        backgroundColor: '#26516F',
                        boxShadow: '0 4px 16px rgba(37, 81, 111, 0.3)',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: '#1c3a52',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 6px 24px rgba(37, 81, 111, 0.4)',
                        },
                        '&:disabled': {
                          backgroundColor: 'rgba(0,0,0,0.12)',
                          color: 'rgba(0,0,0,0.26)',
                        }
                      }}
                    >
                      Save Draft
                    </Button>
                  )}
                  <Button 
                    variant="outlined"
                    size="medium"
                    onClick={handleGoBackHome}
                    startIcon={<HomeIcon />}
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 500,
                      padding: "8px 20px",
                      borderRadius: "8px",
                      borderColor: '#26516F',
                      color: '#26516F',
                      backgroundColor: 'transparent',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#26516F',
                        color: '#fff',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 24px rgba(37, 81, 111, 0.3)',
                      },
                    }}
                  >
                    Home
                  </Button>
                </Box>
              </Box>
              <Box>
                <Stepper 
                  activeStep={activeStep} 
                  alternativeLabel
                  sx={{
                   
                    '& .MuiStepConnector-line': {
                      borderColor: '#26516F',
                      borderTopWidth: { xs: '0.1px', sm: '0.2px' },
                      borderStyle: 'solid',
                    },
                    '& .MuiStep-root': {
                      padding: { xs: '0 2px', sm: '0 8px' },
                    },
                  }}
                >
                  {steps.map((label, index) => {
                    return (
                      <Step key={label}>
                        <StepLabel>
                          <Box
                            className={classes.card}
                            sx={{
                              fontSize: { xs: "0.6rem", sm: "0.75rem", md: "0.875rem" },
                              padding: { xs: "4px 2px", sm: "6px 4px", md: "8px 6px" },
                              bgcolor: activeStep === index ? '#1c5272' : 'grey.500',
                              borderRadius: { xs: "4px", sm: "6px" },
                              minHeight: { xs: "32px", sm: "40px", md: "48px" },
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              textAlign: "center",
                            }}
                          >
                            {label}
                          </Box>
                        </StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                {isDataLoaded ? (
                  activeStep === 0 && (
                    <PersonalInformation
                      handleNext={handleNext}
                      onInformationChange={handlePersonalInformation}
                      personalInformation={personalInformation}
                    />
                  )
                ) : (
                  <Box my={2}>
                    <Skeleton variant="rectangular" width="100%" height={600} />
                  </Box>
                )}
                {activeStep === 1 && (
                  <SocialService
                    handleNext={handleNext}
                    handleBack={handleBack}
                    socialServiceInformation={socialServiceInformation}
                    onInformationChange={handleSocialService}
                  />
                )}
                {activeStep === 2 && (
                  <FamilyComposition
                    handleNext={handleNext}
                    handleBack={handleBack}
                    information={familyCompositionInformation}
                    onInformationChange={handleFamilyComposition}
                    personalInformation={personalInformation}
                    onPersonalInformationChange={handlePersonalInformation}
                  />
                )}
                {activeStep === 3 && (
                  <MedicalBackground
                    handleNext={handleNext}
                    handleBack={handleBack}
                    onInformationChange={handleMedicalBackground}
                    information={medicalBackgroundInformation}
                    onSubmitApplication={handleSubmit}
                  />
                )}
              </Box>
            </div>
          </Box>
        </fieldset>
      </div>
      <SimpleMobileScroll />
    </div>
  );

}

export default withStyles(styles)(ApplicationForm);
